module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-NL":{"customErrorMessage":"Er ontbreken een paar gegevens"},"nl-BE":{"customErrorMessage":"Er ontbreken een paar gegevens"},"es-ES":{"customErrorMessage":"Datos no completos"},"de-DE":{"customErrorMessage":"Einige Daten fehlen"}}')
  delete Component.options._Ctor
}
